import { useCallback } from "react";
import { useSessionTimeoutStore } from "@mirage/store/store";
import { SessionTimeoutState } from "@mirage/store/sessionTimeoutStore";

const useSessionTimeout = () => {
    const openSessionTimeout = useSessionTimeoutStore((s) => s.openSessionTimeout);

    const setSessionTimeout = useCallback(
        (props: Omit<SessionTimeoutState, "open">) => {
            openSessionTimeout(props.timeoutIn);
        },
        [openSessionTimeout]
    );
    return [setSessionTimeout];
};

export default useSessionTimeout;
